import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { getSentryRelease } from '@entscheidungsnavi/tools';
import { CockpitComponent } from './app/cockpit.component';
import { APP_CONFIG } from './app/app.config';
import { ENVIRONMENT } from './environments/environment';

if (ENVIRONMENT.sentryDsn) {
  Sentry.init({
    dsn: ENVIRONMENT.sentryDsn,
    tunnel: '/api/sentry-tunnel',
    release: getSentryRelease({
      environmentType: ENVIRONMENT.type,
      version: ENVIRONMENT.version,
      commitSha: ENVIRONMENT.commitSha,
    }),
    environment: ENVIRONMENT.type,
    ignoreErrors: ['ResizeObserver loop limit exceeded', 'ResizeObserver loop completed with undelivered notifications.'],
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.breadcrumbsIntegration({
        console: true,
        dom: { serializeAttribute: ['data-cy'] },
        fetch: true,
        history: true,
        xhr: true,
      }),
    ],
    tracesSampleRate: 0.8,
  });
}

if (ENVIRONMENT.production) {
  enableProdMode();
}

bootstrapApplication(CockpitComponent, APP_CONFIG).catch(err => console.error(err));
